<template>
  <component :is="currentLayout" />
</template>

<script>
import Default from '@/layouts/LayoutDefault'
export default {
  name: 'App',
  data () {
    return {
      layouts: {
        default: Default
      }
    }
  },
  computed: {
    currentLayout () {
      if (Object.keys(this.$route.meta).includes('layout')) {
        return this.layouts[this.$route.meta.layout]
      }
      return Default
    }
  }
}
</script>
